import { render, staticRenderFns } from "./ExamImport.vue?vue&type=template&id=2ff06d42&"
import script from "./ExamImport.vue?vue&type=script&lang=js&"
export * from "./ExamImport.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports